import {Component, OnInit, Input, ElementRef, ViewChild, ChangeDetectorRef} from '@angular/core';
import {AppComponent} from 'src/app/app.component';
import {LanguageService} from 'src/app/services/language.service';
import {DataService} from 'src/app/services/data.service';
import {LoaderService} from 'src/app/services/loader.service';
import {TranslateService} from '@ngx-translate/core';
import {ModalController, PopoverController} from '@ionic/angular';
import {MenuPopoverComponent} from '../../components/menu-popover/menu-popover.component';
import {PaymentsPage} from '../../modals/payments/payments.page'
import {PaymentsService} from 'src/app/payments.service';
import {PlatformService} from 'src/app/platform.service';
import {Preferences} from '@capacitor/preferences'


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

    @ViewChild('toolbar', {read: ElementRef}) toolbar: ElementRef;
    @Input() title = 'Page Title';
    test = true
    languages = [
        {key: "en", language: "english"},
        {key: "fr", language: "french"}]

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private element: ElementRef,
        public platformSRV: PlatformService,
        public paymentSRV: PaymentsService,
        public modalController: ModalController,
        public popoverController: PopoverController,
        private translate: TranslateService,
        public loaderSRV: LoaderService,
        public dataSRV: DataService,
        public appComp: AppComponent,
    ) {

    }

    async ngOnInit() {
        this.dataSRV.getStoredData({key: "progressWait"}).then(async value => {
            this.paymentSRV.comment = value?.comment + ':' || '';
        });
    }

    async presentMenuPopover(ev: any) {

        const popover = await this.popoverController.create({
            component: MenuPopoverComponent,
            cssClass: 'my-custom-class',
            event: ev,
            translucent: true,
            dismissOnSelect: true
        });

        await popover.present();
    }


}
